import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { Observable } from 'rxjs';
import { TokenService } from '../token.service';
import { UserCompanyService } from '../userCompany.service';
import { AppGuard } from './app.guard';
import { environment } from 'src/environments/environment';
import { CommonConfig } from 'src/app/shared/common-config/common-config';

@Injectable({
  providedIn: 'root'
})
export class UserCompleteGuard {
  init: boolean = false;
  user: any;

  constructor(
    // private tokenService: TokenService,
    private appGuard: AppGuard,
    private userService: UserCompanyService,
    private router: Router,
    private commonConfigService: CommonConfig
  ) {

  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.init) {
      return this._canActivate();
    }
    return new Promise<boolean | UrlTree>((resolve, reject) => {
      const ag = this.appGuard.canActivate();
      if (ag instanceof Promise) {
        ag.then(() => {
          this.userService.user$.subscribe((user) => {
            this.init = true;
            this.user = user;
            resolve(this._canActivate())
          })
        }).catch(() => {
          reject(false)
        })
      } else {
        if(ag == true) {
          this.userService.user$.subscribe((user) => {
          this.init = true;
          this.user = user;
          resolve(this._canActivate())
        })
        } else {
          reject(ag)
        }
      }
      
    });
  }
  _canActivate(): boolean | UrlTree {
    if(this.commonConfigService.getFromConfig('disallowAdminAccess', false) && this.userService.checkUserIsAdmin(this.user)) {
      return this.userService.redirectToAdmin();
    }
    if (!this.user?.name || !this.user?.surname || !this.user?.phone || !this.user?.phonePrefix) {
      return this.router.parseUrl('/account/completeProfile');
    }

    // console.log('can activate_______________________')
    return true;
  }

}
